Inputmask().mask(document.querySelectorAll("input"));
